/* CROOST · producto + Releasit (contra reembolso) + carrito lateral de reserva
   Packs x tono: el id de variante se calcula combinando las dos elecciones. */
(function(){
  function init(){
    var root = document.querySelector('.croost-pp');
    if (!root) return;

    var packs = document.querySelectorAll('.croost-pk');
    var tonos = document.querySelectorAll('.croost-tono');
    var vid = document.getElementById('croostVariantId');
    var sPrice = document.getElementById('croostStickyPrice');
    var sWas = document.getElementById('croostStickyWas');
    var tonoSel = document.getElementById('croostTonoSel');

    /* Dos regalos: envio gratis (siempre) y aplicador (a partir de 2 botes). */
    var giftEls = [document.getElementById('croostRg1'), document.getElementById('croostRg2')];

    var MAP = {};
    try { MAP = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) { MAP = {}; }

    var selPackEl = document.querySelector('.croost-pk.sel');
    var selTonoEl = document.querySelector('.croost-tono.sel');
    var curPack = selPackEl ? selPackEl.getAttribute('data-pack') : '';
    var curTono = selTonoEl ? selTonoEl.getAttribute('data-tono') : '';
    var selGifts = selPackEl ? parseInt(selPackEl.getAttribute('data-gifts'), 10) : 1;
    var busy = false;

    /* La moneda depende del pais del visitante (Shopify Markets).
       Nunca escribirla a mano: se lee del carrito. */
    var CUR = null;

    /* El carrito nativo no se usa: los pedidos los crea Releasit. Lo vaciamos al
       entrar para que el icono de Horizon nunca muestre restos de sesiones viejas. */
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).catch(function(){});

    /* ---------- Releasit ----------
       La app inyecta su propio boton dentro de nuestro formulario. Lo tapamos
       para que solo se vea nuestro CTA, y lo pulsamos por debajo. Releasit lee el
       input name="id", asi que respeta el pack y el tono elegidos.

       TRES TRAMPAS, no las toques sin volver a probar el formulario entero:
       1. NO usar display:none ni visibility:hidden. La app comprueba que el boton
          este visible y entonces el formulario no llega a abrir. Con clip si va.
       2. NO tocar ._rsi-buy-now-button-app-block-hook. Ese div contiene el popup
          (dialog#rsi_form_wrapper), asi que recortarlo o ponerle pointer-events:none
          deja el formulario sin scroll y sin poder escribir en los campos.
       3. position:fixed, no absolute. Con absolute el boton conserva su ancho real
          y estiraba el documento, lo que provocaba scroll horizontal en movil. */
    var st = document.createElement('style');
    st.textContent = '#rsi_buy_now_button{position:fixed!important;top:0!important;left:0!important;clip:rect(0 0 0 0)!important;pointer-events:none!important;margin:0!important;}';
    document.head.appendChild(st);

    function releasitBtn(){
      var b = document.querySelectorAll('#rsi_buy_now_button');
      for (var i = 0; i < b.length; i++) { if (b[i].closest('#croost-buy-form')) return b[i]; }
      return b[0] || null;
    }
    var abriendoReleasit = false;

    function syncVariant(){
      var entry = MAP[curPack + '||' + curTono];
      if (entry && entry.id) vid.value = entry.id;
      if (tonoSel) tonoSel.textContent = curTono;
    }

    /* Ojo: el precio grande de arriba es el precio por bote y NO se toca aqui.
       Es fijo a proposito, para que no se confunda con el total del pack. */
    packs.forEach(function(pk){
      pk.addEventListener('click', function(){
        packs.forEach(function(o){ o.classList.remove('sel'); o.querySelector('input').checked = false; });
        pk.classList.add('sel');
        pk.querySelector('input').checked = true;
        curPack = pk.getAttribute('data-pack');
        if (sPrice) sPrice.textContent = pk.dataset.price;
        if (sWas) sWas.textContent = pk.dataset.was;
        selGifts = parseInt(pk.dataset.gifts, 10);
        giftEls.forEach(function(g, i){ if (g) g.classList.toggle('lock', i >= selGifts); });
        syncVariant();
      });
    });

    tonos.forEach(function(tn){
      tn.addEventListener('click', function(){
        tonos.forEach(function(o){ o.classList.remove('sel'); o.querySelector('input').checked = false; });
        tn.classList.add('sel');
        tn.querySelector('input').checked = true;
        curTono = tn.getAttribute('data-tono');
        syncVariant();
      });
    });

    syncVariant();
    giftEls.forEach(function(g, i){ if (g) g.classList.toggle('lock', i >= selGifts); });

    var guiaBtn = document.getElementById('croostGuiaBtn');
    var guia = document.getElementById('croostGuia');
    if (guiaBtn && guia) {
      guiaBtn.addEventListener('click', function(){ guia.classList.toggle('open'); });
    }

    var moreBtn = document.getElementById('croostMoreReviews');
    if (moreBtn) {
      moreBtn.addEventListener('click', function(){
        document.querySelectorAll('.croost-testi.more').forEach(function(el){ el.classList.remove('more'); });
        moreBtn.style.display = 'none';
      });
    }

    /* ---------- carrito lateral (solo si Releasit no carga) ---------- */
    var ov = document.getElementById('croostDrawerOv');
    var dw = document.getElementById('croostDrawer');
    var dBody = document.getElementById('croostDBody');
    var dFoot = document.getElementById('croostDFoot');

    function fmt(cents){
      var v = (cents || 0) / 100;
      if (CUR) {
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: CUR }).format(v); }
        catch (e) { /* moneda no reconocida, sigue abajo */ }
      }
      return v.toFixed(2) + (CUR ? ' ' + CUR : '');
    }
    function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }
    function getCart(){ return fetch('/cart.js', { headers:{'Accept':'application/json'}, credentials:'same-origin' }).then(function(r){ return r.json(); }); }

    function openDrawer(){ ov.classList.add('open'); dw.classList.add('open'); dw.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
    function closeDrawer(){ ov.classList.remove('open'); dw.classList.remove('open'); dw.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    if (ov) ov.addEventListener('click', closeDrawer);
    var xBtn = document.getElementById('croostDClose');
    if (xBtn) xBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && dw && dw.classList.contains('open')) closeDrawer(); });

    function bindFoot(){
      var co = document.getElementById('croostDCheckout');
      if (co) co.addEventListener('click', function(){ window.location.href = '/checkout'; });
      var bk = document.getElementById('croostDBack');
      if (bk) bk.addEventListener('click', closeDrawer);
    }

    function render(cart){
      if (cart && cart.currency) CUR = cart.currency;

      if (!cart || !cart.items || cart.item_count === 0) {
        dBody.innerHTML = '<div class="croost-dempty">Tu pedido está vacío 🛒</div>';
        dFoot.innerHTML = '<button class="croost-dcont" id="croostDBack">← Seguir viendo</button>';
        bindFoot();
        return;
      }

      var itemsTotal = 0, main = '';
      cart.items.forEach(function(it){
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
        itemsTotal += it.final_line_price;
        var vt = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="dv">' + esc(it.variant_title) + '</div>' : '';
        main += '<div class="croost-ditem">' + img + '<div class="di"><div class="dt">' + esc(it.product_title) + '</div>' + vt + '<div class="dp">' + fmt(it.final_line_price) + '</div></div></div>';
      });

      var regalos = '<div class="croost-dglabel">🎁 Regalos incluidos</div>'
        + '<div class="croost-ditem gift"><div class="di"><div class="dt">Envío gratuito a toda España</div><div class="dp dfree">GRATIS 🎁</div></div></div>'
        + (selGifts >= 2 ? '<div class="croost-ditem gift"><div class="di"><div class="dt">Aplicador de precisión AeroPuff</div><div class="dp dfree">GRATIS 🎁</div></div></div>' : '');

      dBody.innerHTML = main
        + regalos
        + '<div class="croost-dship">💶 Pagas en efectivo al recibirlo · Envío GRATIS en 24-48 h</div>';

      dFoot.innerHTML = '<div class="croost-drow"><span>Productos</span><span>' + fmt(itemsTotal) + '</span></div>'
        + '<div class="croost-drow"><span>Envío</span><span>GRATIS</span></div>'
        + '<div class="croost-dtot"><span>Pagas al recibir</span><span>' + fmt(cart.total_price) + '</span></div>'
        + '<button class="croost-dco" id="croostDCheckout">FINALIZAR PEDIDO 🔒</button>'
        + '<button class="croost-dcont" id="croostDBack">← Seguir viendo</button>';
      bindFoot();
    }

    function addOne(id){
      if (!id || isNaN(id)) return Promise.resolve({ error: 'id invalido' });
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function(r){
        if (!r.ok) { return r.json().then(function(e){ return { error: (e && (e.description || e.message)) || ('HTTP ' + r.status) }; }); }
        return r.json().then(function(){ return { ok: true }; });
      })
      .catch(function(){ return { error: 'sin conexion' }; });
    }

    function showError(msg){
      dBody.innerHTML = '<div class="croost-dempty">No se pudo añadir al pedido.<br><small>' + esc(msg) + '</small></div>';
      dFoot.innerHTML = '<button class="croost-dcont" id="croostDBack">← Cerrar</button>';
      bindFoot();
      openDrawer();
    }

    var buyForm = document.getElementById('croost-buy-form');
    if (buyForm) {
      buyForm.addEventListener('submit', function(e){
        var rb = releasitBtn();

        if (rb) {
          /* Su boton es type=submit y vive dentro de este form. Si el submit ya
             viene de el, no lo volvemos a pulsar o entramos en bucle. */
          if (abriendoReleasit || e.submitter === rb) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          abriendoReleasit = true;
          setTimeout(function(){ abriendoReleasit = false; }, 600);
          rb.click();
          return;
        }

        /* Releasit no ha cargado: carrito lateral de siempre. */
        e.preventDefault();
        if (busy) return;
        busy = true;
        var mainId = parseInt(vid.value, 10);
        var btns = document.querySelectorAll('button[type=submit]');
        btns.forEach(function(b){ b.disabled = true; });

        fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
          .catch(function(){})
          .then(function(){ return addOne(mainId); })
          .then(function(res){ if (res && res.error) { throw new Error(res.error); } })
          .then(getCart)
          .then(function(cart){ render(cart); openDrawer(); })
          .catch(function(err){ showError(err && err.message ? err.message : 'Error desconocido'); })
          .then(function(){ busy = false; btns.forEach(function(b){ b.disabled = false; }); });
      }, true);
    }

    var cta = document.getElementById('croostMainCta');
    var sticky = document.getElementById('croostSticky');
    if (cta && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries){
        sticky.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(cta);
    }

    /* ---------- sliders ---------- */
    function croostSlider(trackId, dotsId, gap, thumbsId){
      var track = document.getElementById(trackId);
      if (!track) return;
      var dots = document.getElementById(dotsId);
      var thumbs = thumbsId ? document.getElementById(thumbsId) : null;
      var slides = track.children;
      if (slides.length < 2) { if (dots) dots.style.display='none'; if (thumbs) thumbs.style.display='none'; return; }

      if (dots) {
        for (var i = 0; i < slides.length; i++) {
          (function(idx){
            var d = document.createElement('span');
            if (idx === 0) d.className = 'on';
            d.addEventListener('click', function(){ goTo(idx); });
            dots.appendChild(d);
          })(i);
        }
      }

      var timgs = thumbs ? thumbs.querySelectorAll('img') : [];
      timgs.forEach(function(t, i){
        if (i === 0) t.classList.add('on');
        t.addEventListener('click', function(){ goTo(i); });
      });

      function goTo(idx){
        track.scrollTo({ left: idx * (slides[0].offsetWidth + gap), behavior: 'smooth' });
      }

      function mark(idx){
        if (dots) { for (var i = 0; i < dots.children.length; i++) dots.children[i].className = (i === idx) ? 'on' : ''; }
        timgs.forEach(function(t, i){ t.classList.toggle('on', i === idx); });
      }

      var ticking = false;
      track.addEventListener('scroll', function(){
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function(){
          var w = slides[0].offsetWidth + gap;
          var idx = Math.round(track.scrollLeft / w);
          if (idx > slides.length - 1) idx = slides.length - 1;
          if (idx < 0) idx = 0;
          mark(idx);
          ticking = false;
        });
      }, { passive: true });
    }

    croostSlider('croostGalTrack', 'croostGalDots', 10, 'croostGalThumbs');
    croostSlider('croostVetTrack', 'croostVetDots', 10);
    croostSlider('croostGifTrack', 'croostGifDots', 12);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
